module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-3000.5860adf1.svg";